import React from "react";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import importAll from "../../../lib/utils/image";
import CloudinaryImage from "../../Common/CloudinaryImage";

const TheyTrustUs = () => {
  const { t } = useTranslation("our-expertise");
  const allImages = importAll(
    require.context(
      "../../../public/static/images/our-expertise/they-trust-us",
      false,
      /\.(png|jpe?g|svg|webp)$/
    )
  );
  const blocks = t("they_trust_us.blocks", { returnObjects: true });

  return (
    <Box>
      <Box marginTop={2} marginBottom={2}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"textSecondary"}
          align={"center"}
        >
          {t("they_trust_us.title")}
        </Typography>
      </Box>
      <Box marginBottom={3}>
        <Box display="flex" flexWrap="wrap" justifyContent={"center"}>
          {blocks.map((item, i) => (
            <Box marginTop={2} marginRight={7} key={i}>
              <CloudinaryImage
                src={allImages[item.fileName]}
                alt={`Logo ${item.name}`}
                title={item.name}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default TheyTrustUs;
